// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failureCauseCategories__lBQdE {
  padding: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: calc(100% - 55px);
}
.failureCauseCategories__lBQdE::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.failureCauseCategories__lBQdE::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.failureCauseCategories__lBQdE::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.failureCauseCategories__lBQdE::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 850px) {
  .failureCauseCategories__lBQdE {
    padding: 15px;
    row-gap: 15px;
  }
}

.failureCauseCategoriesTableWrapper__c7h5u {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 155px);
  overflow: auto;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
}
.failureCauseCategoriesTableWrapper__c7h5u::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.failureCauseCategoriesTableWrapper__c7h5u::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.failureCauseCategoriesTableWrapper__c7h5u::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.failureCauseCategoriesTableWrapper__c7h5u::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 850px) {
  .failureCauseCategoriesTableWrapper__c7h5u {
    max-height: calc(100vh - 125px);
  }
}

.failureCauseCategoriesTable__lZIBr {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.failureCauseCategoriesTable__lZIBr .tableHead__huWjg {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dateRangeFilter__r48q0 {
  width: 215px;
}

.sortIcon__iIn8e {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__iIn8e path {
  fill: var(--tables-title-icon);
}

.activeSort__pUdsg path {
  fill: var(--tables-primary-row-icon);
}

.tableFooter__TvrLm {
  height: 24px;
  text-align: right;
}

.filtersBlock__Rj131 {
  display: flex;
  align-items: center;
  column-gap: 15px;
  border: 1px solid var(--header-stroke);
  background: var(--tables-primary-row-surface-default);
  padding: 15px 25px;
}

.skeletonTab__tte7r {
  width: 447px;
  height: 35px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/FailureCauseCategories/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;AAzEF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;AA2DE;EARF;IASI,aAAA;IACA,aAAA;EAxDF;AACF;;AA2DA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,yDAAA;EACA,qDAAA;EACA,mCAAA;AAxDF;AAbE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAeJ;AAZE;EACE,+BAAA;EACA,kBAAA;AAcJ;AAXE;EACE,8BAAA;EACA,kBAAA;AAaJ;AAVE;EACE,gBAAA;EACA,kBAAA;AAYJ;AA2CE;EAXF;IAYI,+BAAA;EAxCF;AACF;;AA2CA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAxCF;AA0CE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAxCJ;;AA4CA;EACE,YAAA;AAzCF;;AA4CA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAzCF;AA2CE;EACE,8BAAA;AAzCJ;;AA8CE;EACE,oCAAA;AA3CJ;;AA+CA;EACE,YAAA;EACA,iBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qDAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,YAAA;EACA,YAAA;AA5CF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.failureCauseCategories {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: calc(100% - 55px);\n  @include scrollBar;\n\n  @media (max-width: 850px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.failureCauseCategoriesTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 155px);\n  overflow: auto;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n\n  @include scrollBar;\n\n  @media (max-width: 850px) {\n    max-height: calc(100vh - 125px);\n  }\n}\n\n.failureCauseCategoriesTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  .tableHead {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n}\n\n.dateRangeFilter {\n  width: 215px;\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.tableFooter {\n  height: 24px;\n  text-align: right;\n}\n\n.filtersBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n  border: 1px solid var(--header-stroke);\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px 25px;\n}\n\n.skeletonTab {\n  width: 447px;\n  height: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"failureCauseCategories": `failureCauseCategories__lBQdE`,
	"failureCauseCategoriesTableWrapper": `failureCauseCategoriesTableWrapper__c7h5u`,
	"failureCauseCategoriesTable": `failureCauseCategoriesTable__lZIBr`,
	"tableHead": `tableHead__huWjg`,
	"dateRangeFilter": `dateRangeFilter__r48q0`,
	"sortIcon": `sortIcon__iIn8e`,
	"activeSort": `activeSort__pUdsg`,
	"tableFooter": `tableFooter__TvrLm`,
	"filtersBlock": `filtersBlock__Rj131`,
	"skeletonTab": `skeletonTab__tte7r`
};
module.exports = ___CSS_LOADER_EXPORT___;
